package data.objects

import search.searchFilterStores.ActiveFieldValuesStore

class ActiveObjectFieldValuesStore : ActiveFieldValuesStore()